<template>
  <v-card class="add-new-org__card">
    <div class="add-new-org__title h3">Company details</div>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <div class="small-extra-bold ">
          Company registration number
        </div>
        <form-group
          :validations="$v.organisation.company_registration_number"
          class="form-group"
        >
          <div slot-scope="{ errors }">
            <v-text-field
              class=""
              outlined
              dense
              hide-details="auto"
              placeholder="Type here..."
              v-model="$v.organisation.company_registration_number.$model"
            />
            <div class="form-field-error">{{ errors[0] || "" }}</div>
          </div>
        </form-group>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <div class="small-extra-bold ">
          VAT number
        </div>
        <form-group
          :validations="$v.organisation.vat_number"
          class="form-group"
        >
          <div slot-scope="{ errors }">
            <v-text-field
              outlined
              dense
              hide-details="auto"
              placeholder="Type here..."
              v-model="$v.organisation.vat_number.$model"
            />

            <div class="form-field-error">{{ errors[0] || "" }}</div>
          </div>
        </form-group>
      </v-col>
    </v-row>
     <div class="apio__card-actions">
      <apio-button button-type="secondary" @click="stepBack">Back</apio-button>
      <apio-button @click="save" :disabled="!isFormValid">{{ organisationDetails.ID ? 'Update' : 'Confirm changes' }}</apio-button>
    </div>
  </v-card>
</template>

<script>
import { validationMixin } from "vuelidate";
export default {
  name: "AddOrgCompanyDetails",
  props: {
    organisationDetails: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      title: "",
      organisation: {
        company_registration_number: "",
        vat_number: "",
      },
    };
  },
  validations: {
    organisation: {
      company_registration_number: {
      },
      vat_number: {
      },
    },
  },
  mixins: [validationMixin],
  components: {
    ApioButton: () => import("@/components/Misc/Button.vue"),
    FormGroup: () => import("@/pages/Account/FormGroup"),
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  created() {
    if(this.$route.params.id) { 
      Object.assign(this.organisation, this.organisationDetails);
      this.$forceUpdate();
    }
  },
  methods: {
    stepBack() {  
      const { company_registration_number, vat_number } = this.organisation;
      this.$emit("step", { org: { company_registration_number, vat_number }, step: 2 });
    },
    save() {
      const { company_registration_number, vat_number } = this.organisation;
      this.$emit("step", { org: { company_registration_number, vat_number }, step: 3, complete: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-org {
  &__card {
    color: var(--apio-shade-2);
  }
  &__title {
    padding-bottom: 24px;
  }
}
</style>